import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-brand-bg py-8 border-t border-brand-cardDark/30 text-center px-6" data-id="element-8">
      <p className="text-brand-text/50 text-sm" data-id="element-9">
        © {currentYear} Crea y Vende Tu Primer Producto Digital. Todos los
        derechos reservados.
      </p>
      <div className="mt-4 flex justify-center gap-4 text-xs text-brand-text/40" data-id="element-10">
        <a href="#" className="hover:text-brand-text/70 transition-colors" data-id="element-11">
          Términos y Condiciones
        </a>
        <a href="#" className="hover:text-brand-text/70 transition-colors" data-id="element-12">
          Política de Privacidad
        </a>
      </div>
    </footer>;
}